import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import PagmusLogo from '../assets/logo/PagmuslogoNegativa.svg';
import styles from './SignInLayer.module.scss';

const SignInLayer = ({ handleAuthenticate, loading, error }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [lottieAnimation, setLottieAnimation] = useState(null);

  // Carregar animação Lottie
  useEffect(() => {
    let isMounted = true;
    
    fetch('/assets/animations/password-auth.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Animação não encontrada');
        }
        return response.json();
      })
      .then(data => {
        if (isMounted) {
          setLottieAnimation(data);
        }
      })
      .catch(error => {
        console.warn('Animação Lottie não disponível, usando fallback:', error);
        if (isMounted) {
          setLottieAnimation(null);
        }
      });
    
    return () => {
      isMounted = false;
    };
  }, []);

  const showHidePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAuthenticate({ email, password });
  };

  return (
    <div className={styles.signinV2Container}>
      {/* Background com gradiente animado */}
      <div className={styles.signinV2Background}>
        <div className={`${styles.gradientOrb} ${styles.orb1}`}></div>
        <div className={`${styles.gradientOrb} ${styles.orb2}`}></div>
        <div className={`${styles.gradientOrb} ${styles.orb3}`}></div>
      </div>

      {/* Conteúdo principal */}
      <div className={styles.signinV2Content}>
                  {/* Lado esquerdo - Hero Section Elegante */}
          <div className={styles.signinV2Left}>
            <div className={styles.signinV2Hero}>
              {/* Logo em Destaque */}
              <div className={styles.brandHeader}>
                <img src={PagmusLogo} alt="Pagmus" className={styles.brandLogoMain} />
              </div>

              {/* Hero Content - Animação Lottie */}
              <div className={styles.heroContent}>
                <div className={styles.heroVisual}>
                  {/* Animação Lottie de Autenticação */}
                  <div className={styles.lottieAnimationContainer}>
                    {lottieAnimation ? (
                                          <Lottie
                      animationData={lottieAnimation}
                      loop={true}
                      autoplay={true}
                      className={styles.passwordAuthAnimation}
                    />
                    ) : (
                      <div className={styles.loadingPlaceholder}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Carregando...</span>
                        </div>
                        <span>Carregando animação...</span>
                      </div>
                    )}
                  </div>
                </div>
                
                <div className={styles.heroText}>
                  <span className={styles.heroTitle}>Transforme suas ideias em vendas digitais</span>
                  <p>A plataforma completa para criadores de conteúdo e afiliados expandirem seus negócios</p>
                  
                  <div className={styles.statsPreview}>
                    <div className={styles.statItem}>
                      <strong>10k+</strong>
                      <span>Produtos</span>
                    </div>
                    <div className={styles.statItem}>
                      <strong>50k+</strong>
                      <span>Usuários</span>
                    </div>
                    <div className={styles.statItem}>
                      <strong>R$ 5M+</strong>
                      <span>Faturado</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        {/* Lado direito - Formulário */}
        <div className={styles.signinV2Right}>
          <div className={styles.signinV2FormContainer}>
            <div className={styles.formHeader}>
              <div className={styles.welcomeBadge}>
                <span>✨ Bem-vindo de volta!</span>
              </div>
              <h2>Acesse sua conta</h2>
              <p>Entre na sua conta para acessar o dashboard e gerenciar seus produtos</p>
            </div>

            <form onSubmit={handleSubmit} className={styles.signinV2Form}>
              {/* Campo Email */}
              <div className={styles.formGroup}>
                <label htmlFor="email">E-mail</label>
                <div className={styles.inputWrapper}>
                  <input
                    type="email"
                    id="email"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="username"
                    required
                  />
                </div>
              </div>

              {/* Campo Senha */}
              <div className={styles.formGroup}>
                <label htmlFor="password">Senha</label>
                <div className={styles.inputWrapper}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Sua senha"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={showHidePassword}
                  >
                    {showPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
              </div>

              {/* Mensagem de erro */}
              {error && (
                <div className={styles.signinErrorMessage}>
                  <span className={styles.errorIcon}>⚠️</span>
                  <span>{error}</span>
                </div>
              )}

              {/* Lembrar e Esqueceu senha */}
              <div className={styles.formOptions}>
                <label className={styles.checkboxWrapper}>
                  <input type="checkbox" />
                  <span className={styles.checkmark}></span>
                  Lembrar de mim
                </label>
                <Link to="/forgot-password" className={styles.forgotLink}>
                  Esqueceu a senha?
                </Link>
              </div>

              {/* Botão de Login */}
              <button
                type="submit"
                className={`${styles.signinBtn} ${loading ? styles.loading : ''}`}
                disabled={loading || !email}
              >
                {loading ? (
                  <>
                    <div className="spinner-border spinner-border-sm me-2" role="status">
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                    Entrando...
                  </>
                ) : (
                  <>
                    🔐 Entrar na conta
                  </>
                )}
              </button>

              {/* Link para cadastro */}
              <div className={styles.signupLink}>
                <p>
                  Ainda não tem uma conta?{" "}
                  <Link to="/sign-up">Cadastre-se gratuitamente</Link>
                </p>
              </div>
            </form>

            {/* Features */}
            <div className={styles.featuresList}>
              <div className={styles.featureItem}>
                <span>🛡️ 100% Seguro</span>
              </div>
              <div className={styles.featureItem}>
                <span>⚡ Acesso Instantâneo</span>
              </div>
              <div className={styles.featureItem}>
                <span>🎧 Suporte 24/7</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInLayer;